import React from 'react';
import ReactDOM from 'react-dom';
import { FilterContext } from '../../Components/Context/FilterContext';
import FilterContainer from '../../Components/Filter/Container/FilterContainer';
import ProductsContainer from '../../Components/Filter/Container/ProductsContainer';
import { AccountContext } from '../../Components/Context/AccountContext';

const filterControlsDomContainer = document.querySelector('#js-filter-dom-container') as HTMLElement;
const filterResultDomContainer = document.querySelector('#js-filter-dom-product-container') as HTMLElement;

// container that is filled by server by default for this care step with unfiltered products
const serverRenderDomContainer = document.querySelector('#js-server-dom-product-container') as HTMLElement;

export default function FilterIntegrations() {
    const { isFilterActive } = React.useContext(FilterContext);
    const { isLoggedIn } = React.useContext(AccountContext);

    const FilteredProductsContainer = () => {
        if (isFilterActive || isLoggedIn) {
            // hide server-generated product overview
            serverRenderDomContainer.classList.add('d-none');

            return ReactDOM.createPortal(<ProductsContainer />, filterResultDomContainer);
        } else {
            serverRenderDomContainer.classList.remove('d-none');
        }

        return null;
    };

    if (filterControlsDomContainer && filterResultDomContainer) {
        return (
            <>
                {ReactDOM.createPortal(<FilterContainer />, filterControlsDomContainer)}
                <FilteredProductsContainer />
            </>
        );
    }

    return null;
}
